import PropTypes from "prop-types";
import React, { Fragment, useContext, useEffect, useState } from "react";
import { NavLink, withRouter } from "react-router-dom";
import { Col, Collapse, Nav, NavItem, NavLink as BootstrapNavLink, Row } from "reactstrap";
import AppContext from "../../context/Context";
import NavbarVerticalMenuItem from "./NavbarVerticalMenuItem";

const NavbarVerticalMenu = ({ routes, location, showIcon }) => {
  const [openedIndex, setOpenedIndex] = useState(null);
  const { setShowBurgerMenu, loginUserDetails } = useContext(AppContext);

  useEffect(() => {
    let openedDropdown = null;
    routes.forEach((route, index) => {
      if (location.pathname.indexOf(route.to) === 0) openedDropdown = index;
    });

    setOpenedIndex(openedDropdown);
    // eslint-disable-next-line
  }, []);

  const toggleOpened = (e, index) => {
    e.preventDefault();
    return setOpenedIndex(openedIndex === index ? null : index);
  };

  // const getHr = name => {
  //   if (name === 'Widgets' || name === 'Documentation') {
  //     return (
  //       <div className="navbar-vertical-divider">
  //         <hr className="navbar-vertical-hr my-2" />
  //       </div>
  //     );
  //   }
  // };

  return routes.map((route, index) => {
    if (!route.children) {
      if (route.name === "API Documentation") {
        return (
          <Col key={index}>
            <NavItem style={{ marginLeft: "9px" }}>
              <NavbarVerticalMenuItem route={route} icon="faUpRightFromSquare" />
            </NavItem>
          </Col>
        );
      }
      else if (route.name === "Writeback APIs") {
        return (
          <Col key={index}>
            <NavItem style={{ marginLeft: "9px" }}>
              <NavbarVerticalMenuItem route={route} icon="faUpRightFromSquare" />
            </NavItem>
          </Col>
        );
      }
      else if (route.name === "Practice Onboarding") {
        return (
          <Col key={index}>
            <NavItem style={{ marginLeft: "9px" }}>
              <NavbarVerticalMenuItem route={route} icon="faUpRightFromSquare" />
            </NavItem>
          </Col>
        );
      }
      else if (route.name === "Ask Me..!") {
        return (
          <Col key={index}>
            <NavItem style={{ marginLeft: "-1em" }}>
              <NavbarVerticalMenuItem route={route} icon="faUpRightFromSquare" />
            </NavItem>
          </Col>
        );
      }
      else if (route.name === "API Status") {
        return loginUserDetails.is_partner === "1" ? (
          <Col className="px-0 mx-0 mb-2 mt-1" key={index}>
            <NavItem>
              <NavbarVerticalMenuItem route={route} icon="faUpRightFromSquare" />
            </NavItem>
          </Col>
        ) : (
          <Col key={index}>
            <NavItem style={{ marginLeft: "9px" }}>
              <NavbarVerticalMenuItem route={route} icon="faUpRightFromSquare" />
            </NavItem>
          </Col>
        );
      } 
      // else if (route.name === "Tickets") {
      //   return loginUserDetails.freshdesk_id === "" && loginUserDetails.is_partner =="1"? (
      //     <Col key={index}>
      //       <NavItem style={{ marginLeft: "9px" }}>
      //         <NavbarVerticalMenuItem route={route} icon="faUpRightFromSquare" />
      //       </NavItem>
      //     </Col>
      //   ) : (
      //     <NavItem style={{ marginBottom: "3px"}} key={index}>
      //       <NavLink className="nav-link" {...route} onClick={() => setShowBurgerMenu(false)}>
      //         <NavbarVerticalMenuItem route={route} icon={false} />
      //       </NavLink>
      //     </NavItem>
      //   );
      // }
      else {
        return (
          <NavItem style={{ marginBottom: "3px"}} key={index}>
            <NavLink className="nav-link" {...route} onClick={() => setShowBurgerMenu(false)}>
              <NavbarVerticalMenuItem route={route} icon={false} />
            </NavLink>
          </NavItem>
        );
      }
    }
    return (
      <Fragment key={index}>
        <NavItem style={{ marginBottom: "3px" }}>
          <BootstrapNavLink
            onClick={(e) => toggleOpened(e, index)}
            className="dropdown-indicator cursor-pointer"
            aria-expanded={openedIndex === index}
          >
            <NavbarVerticalMenuItem route={route} showIcon={route} />
          </BootstrapNavLink>
          <Collapse isOpen={openedIndex === index}>
            <Nav>
              <NavbarVerticalMenu routes={route.children} location={location} />
            </Nav>
          </Collapse>
        </NavItem>
      </Fragment>
    );
  });
};

NavbarVerticalMenu.propTypes = {
  routes: PropTypes.array.isRequired,
  location: PropTypes.object.isRequired,
};

export default withRouter(NavbarVerticalMenu);
